import {useCountTicketsQuery} from "@MyProfile/API/myProfileApi";

export default function useCountValidTickets() {
    const {
        data,
        isUninitialized,
        isLoading,
    } = useCountTicketsQuery({showValid: true})

    const validTicketsCountLoading = isUninitialized || isLoading

    return {
        validTicketsCount: data?.count,
        validTicketsCountLoading,
    }
}